import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../../routes/Routes';
import CustomAxios from '../../../../utility/customAxios';

export const postGoogleAuthCode = async (code: string) => {
  const response = await CustomAxios.post(`integrations/google/callback`, { code });
  const { data } = response;
  return data;
};

export function useCreateGoogleAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (code: string) => postGoogleAuthCode(code),
    onSuccess: () => {
      navigate(`/${ROUTE_PATHS.INTEGRATIONS}`);
    },
    onError: (err: AxiosError) => {
      console.error('Error saving token:', err);
      if (err.response?.status === 400) {
        alert((err.response?.data as any).error);
        navigate('/integrations');
        return;
      }
      navigate('/');
    },
  });
}
